// extracted by mini-css-extract-plugin
module.exports = {"tank":"style_tank__2o_kY"};